export default __webpack_public_path__ + "static/media/Flag_of_Denmark.c0523a20.svg";